module.exports = {
  textarea: {
    write_default: '',
    write_max: 200,
    write_min: 0
  }
}



// WEBPACK FOOTER //
// ./src/components/Model/widgetAttr/textarea.js